module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-bg-885e8a951994206ba440f747a103dffe.jpg";